module.exports = __webpack_public_path__ + "img/China.8c968468.png";